import { theme } from 'antd';

const { useToken } = theme;

const PumpIcon = ({
  color,
  width = 22,
  height = 22,
  ...rest
}: {
  color?: string;
  width?: number;
  height?: number;
}) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorIcon;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 23 19"
      fill="none"
      style={{ flexShrink: 0 , aspectRatio: '22.13/18.11'}}
      {...rest}
    >
      <path
        d="M7.06641 0C7.5841 0.000160095 8.00375 0.419805 8.00391 0.9375C8.00391 1.45533 7.5842 1.87582 7.06641 1.87598H6.37402V2.73047H6.74609C7.02224 2.73047 7.24609 2.95433 7.24609 3.23047V5.74121H8.25879C8.36608 4.76809 8.51937 3.99576 8.66504 3.4248C8.85801 2.66872 9.55856 2.20918 10.3389 2.20898H19.6484C20.4953 2.20919 21.2475 2.74445 21.4434 3.56836C21.7082 4.68264 22.0117 6.38484 21.999 8.30469C21.9864 10.2094 21.6913 11.9 21.4355 13.0146C21.2437 13.8507 20.4837 14.4003 19.626 14.4004H19.1992V15.8594H21.627C21.9031 15.8594 22.127 16.0832 22.127 16.3594V17.6104C22.1268 17.8864 21.903 18.1104 21.627 18.1104H0.827148C0.551095 18.1104 0.327292 17.8864 0.327148 17.6104V16.3594C0.327148 16.0832 0.551006 15.8594 0.827148 15.8594H2.7168V9.49316H1.87598V10.0898C1.87589 10.6076 1.4553 11.0273 0.9375 11.0273C0.419844 11.0272 9.04421e-05 10.6075 0 10.0898V5.86914C0.000105378 5.35148 0.419853 4.93181 0.9375 4.93164C1.45529 4.93164 1.87587 5.35137 1.87598 5.86914V6.67969H2.7168V3.23047C2.7168 2.95433 2.94163 2.73047 3.21777 2.73047H3.56055V1.87598H2.84668C2.32884 1.87588 1.90918 1.45537 1.90918 0.9375C1.90934 0.419768 2.32893 0.000100971 2.84668 0H7.06641ZM7.24609 15.8594H11.1992V14.4004H10.3379C9.55835 14.4004 8.8584 13.9416 8.66504 13.1865C8.49771 12.5322 8.31914 11.613 8.21387 10.4297H7.24609V15.8594ZM11.8721 11.3711H13.0723V4.80664H11.8721V11.3711ZM14.1631 11.3711H15.3633V4.80664H14.1631V11.3711Z"
        fill={currentColor}
      />
    </svg>
  );
};

export default PumpIcon;

